(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battery-swap-game"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  if (window.__mbgLoaded) return;
  window.__mbgLoaded = true;

  var TOOLS = { key: "key", hex: "hex key", spanner: "spanner", brush: "wire brush", gloves: "gloves" };

  var STEPS = [
    { tool: "key", target: "ignition", title: "Switch off and pull the key",
      why: "Dead circuit first. Nothing can arc while you work.",
      trap: { target: "seat", tool: "hex", msg: "Not yet. Pull the key before you take anything apart." } },
    { tool: "hex", target: "seat", title: "Take the seat off with the hex key",
      why: "The battery sits under the seat, and now you can reach it." },
    { tool: "spanner", target: "neg", title: "Undo the negative (−) cable first",
      why: "Negative first: a slipped spanner can’t complete a circuit through the frame.",
      trap: { target: "pos", tool: "spanner", msg: "Spark! Take positive off first and a slipped spanner can touch the frame and short. Negative comes off first." } },
    { tool: "spanner", target: "pos", title: "Now undo the positive (+) cable",
      why: "Both cables are clear, so the battery is isolated." },
    { tool: "gloves", target: "battery", title: "Lift the old battery out",
      why: "Gloves on, keep it upright. An old battery can leak acid." },
    { tool: "brush", target: "tray", title: "Brush the tray clean",
      why: "Corrosion left in the tray attacks the new battery and the cable ends." },
    { tool: "gloves", target: "tray", title: "Set the new battery in the tray",
      why: "Terminals face the same way as before, so the cables still reach." },
    { tool: "spanner", target: "pos", title: "Connect positive (+) first",
      why: "With negative still off, a slip of the spanner can’t complete a circuit.",
      trap: { target: "neg", tool: "spanner", msg: "Spark! Negative goes on last. Connect it first and the spanner on positive can short against the frame." } },
    { tool: "spanner", target: "neg", title: "Connect negative (−) last",
      why: "Circuit complete. Snug is enough: the posts are soft lead." },
    { tool: "hex", target: "seat", title: "Refit the seat",
      why: "Covered and clipped in, with no loose wires to snag." },
    { tool: "key", target: "ignition", title: "Key in. Start the bike.",
      why: "It fires on the first turn." }
  ];

  function fmt(t) {
    var m = Math.floor(t / 60), s = t % 60;
    return m + ":" + (s < 10 ? "0" : "") + s;
  }

  function init(root) {
    if (root.getAttribute("data-ready")) return;
    root.setAttribute("data-ready", "1");

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var svg = q("[data-svg]");
    var stage = q("[data-stage]");
    var elTask = q("[data-task]");
    var elScore = q("[data-score]");
    var elTime = q("[data-time]");
    var elCells = q("[data-cells]");
    var elBar = q("[data-bar]");
    var elFeedback = q("[data-feedback]");
    var btnHint = q("[data-hint]");
    var ovStart = q("[data-start]");
    var ovEnd = q("[data-end]");
    var tools = qa("[data-tool]");
    var targets = qa("[data-target]");
    var fxSpark = q("[data-fx='spark']");
    var fxOk = q("[data-fx='ok']");
    var maxLives = parseInt(root.getAttribute("data-lives"), 10) || 3;
    var S = null;
    var timer = null;

    function newState(mode) {
      return { mode: mode, c: 0, lives: maxLives, score: 0, slips: 0, tool: null, secs: 0, t0: Date.now(), hinted: false, over: false };
    }

    function say(text, kind) {
      elFeedback.textContent = text || "";
      elFeedback.className = "mbg__feedback" + (kind ? " is-" + kind : "");
    }

    function setToolsEnabled(on) {
      tools.forEach(function (b) { b.disabled = !on; });
    }

    function selectTool(name) {
      if (S) S.tool = name;
      tools.forEach(function (b) {
        b.setAttribute("aria-pressed", b.getAttribute("data-tool") === name ? "true" : "false");
      });
    }

    function render() {
      var c = S.c;
      var flags = {
        "is-key-out": c >= 1 && c < 11,
        "is-seat-off": c >= 2 && c < 10,
        "is-neg-off": c >= 3 && c < 9,
        "is-pos-off": c >= 4 && c < 8,
        "is-old-out": c >= 5,
        "is-clean": c >= 6,
        "is-new-in": c >= 7,
        "is-running": c >= 11
      };
      Object.keys(flags).forEach(function (k) { svg.classList.toggle(k, flags[k]); });

      elScore.textContent = S.score;
      elTime.textContent = fmt(S.secs);
      elBar.style.width = (c / STEPS.length * 100) + "%";

      var cells = "";
      for (var i = 0; i < maxLives; i++) cells += '<i class="mbg__cell' + (i < S.lives ? " is-full" : "") + '"></i>';
      elCells.innerHTML = cells;
      elCells.setAttribute("aria-label", "Charge: " + S.lives + " of " + maxLives);

      if (S.idle) {
        elTask.textContent = "Choose a mode to begin.";
      } else if (c >= STEPS.length) {
        elTask.textContent = "Bike running. Job done.";
      } else {
        var label = "Step " + (c + 1) + " of " + STEPS.length;
        var show = S.mode === "guided" || S.hinted;
        elTask.textContent = label + (show ? ": " + STEPS[c].title : ": work out what comes next.");
      }
      btnHint.hidden = !(S.mode === "mechanic" && !S.hinted && !S.over && !S.idle);
    }

    function centre(el) {
      var a = el.querySelector("[data-anchor]") || el;
      var r = a.getBoundingClientRect();
      var s = svg.getBoundingClientRect();
      var k = 640 / s.width;
      return { x: (r.left + r.width / 2 - s.left) * k, y: (r.top + r.height / 2 - s.top) * k };
    }

    function fx(kind, el) {
      var g = kind === "spark" ? fxSpark : fxOk;
      var p = centre(el);
      g.style.transform = "translate(" + p.x + "px," + p.y + "px)";
      var inner = g.querySelector(".mbg-fx__in");
      inner.classList.remove("is-on");
      void inner.getBoundingClientRect();
      inner.classList.add("is-on");
    }

    function judge(step, tool, target) {
      if (tool === step.tool && target === step.target) return null;
      if (step.trap && step.trap.target === target && step.trap.tool === tool) return step.trap.msg;
      if (target === step.target) return "Right spot, wrong tool. The " + TOOLS[tool] + " can’t do this job.";
      if (S.c < 2 && (target === "neg" || target === "pos" || target === "battery" || target === "tray")) {
        return "The seat is still on, so you can’t reach the battery.";
      }
      if (S.c >= 2 && S.c < 5 && target === "tray") return "The old battery is still sitting in the tray.";
      return "Not yet. That isn’t the next job.";
    }

    function finish(win) {
      S.over = true;
      clearInterval(timer);
      setToolsEnabled(false);
      selectTool(null);
      btnHint.hidden = true;

      setTimeout(function () {
        var stars = win ? (S.slips === 0 ? 3 : S.slips <= 1 ? 2 : 1) : 0;
        var title, text;
        if (win) {
          title = stars === 3 ? "Clean job" : stars === 2 ? "Bike’s running" : "It runs, just about";
          text = stars === 3 ? "No slips. The new battery is in and the bike starts first time."
               : stars === 2 ? "One slip, but the battery is in right and the bike starts."
               : "Several close calls. Try again and keep to the order: negative off first, negative on last.";
        } else {
          title = "Short circuit";
          text = "The fuse blew. You were on step " + (S.c + 1) + ": " + STEPS[S.c].title.toLowerCase() + ".";
        }
        q("[data-stars]").textContent = win ? new Array(stars + 1).join("★") + new Array(4 - stars).join("☆") : "";
        q("[data-stars]").setAttribute("aria-label", win ? stars + " of 3 stars" : "");
        q("[data-end-title]").textContent = title;
        q("[data-end-text]").textContent = text;
        q("[data-end-score]").textContent = S.score;
        q("[data-end-time]").textContent = fmt(S.secs);
        q("[data-end-slips]").textContent = S.slips;
        ovEnd.hidden = false;
        q("[data-replay]").focus();
      }, win ? 1200 : 800);
    }

    function act(name, el) {
      if (!S || S.over || S.idle) return;
      if (!S.tool) { say("Pick a tool from the toolbox first.", ""); return; }
      var step = STEPS[S.c];
      var problem = judge(step, S.tool, name);

      if (problem) {
        S.lives--; S.slips++;
        S.score = Math.max(0, S.score - 50);
        fx("spark", el);
        stage.classList.remove("is-shake");
        void stage.offsetWidth;
        stage.classList.add("is-shake");
        say(problem, "bad");
        render();
        if (S.lives <= 0) finish(false);
        return;
      }

      var elapsed = (Date.now() - S.t0) / 1000;
      var bonus = Math.max(0, 50 - Math.round(elapsed * 4));
      S.score += (100 + bonus) * (S.mode === "mechanic" ? 2 : 1);
      S.c++; S.t0 = Date.now(); S.hinted = false;
      fx("ok", el);
      say(step.why, "good");
      render();
      if (S.c >= STEPS.length) finish(true);
    }

    function showStart() {
      clearInterval(timer);
      S = newState("guided");
      S.idle = true; S.over = true;
      selectTool(null);
      setToolsEnabled(false);
      say("", "");
      render();
      ovEnd.hidden = true;
      ovStart.hidden = false;
    }

    function start(mode) {
      clearInterval(timer);
      S = newState(mode);
      ovStart.hidden = true;
      ovEnd.hidden = true;
      selectTool(null);
      setToolsEnabled(true);
      say("", "");
      render();
      timer = setInterval(function () {
        if (!S || S.over) return;
        S.secs++;
        elTime.textContent = fmt(S.secs);
      }, 1000);
      if (tools[0]) tools[0].focus();
    }

    tools.forEach(function (b) {
      b.addEventListener("click", function () {
        if (!S || S.over) return;
        var name = b.getAttribute("data-tool");
        selectTool(S.tool === name ? null : name);
      });
    });

    targets.forEach(function (el) {
      var name = el.getAttribute("data-target");
      el.addEventListener("click", function () { act(name, el); });
      el.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); act(name, el); }
      });
    });

    qa("[data-mode]").forEach(function (b) {
      b.addEventListener("click", function () { start(b.getAttribute("data-mode")); });
    });

    q("[data-replay]").addEventListener("click", function () {
      showStart();
      var first = q("[data-mode]");
      if (first) first.focus();
    });

    btnHint.addEventListener("click", function () {
      if (!S || S.over || S.hinted) return;
      S.hinted = true;
      S.score = Math.max(0, S.score - 25);
      render();
    });

    showStart();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-mbg]"), init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
